<template>
<v-container grid-list-xl fluid>
    <v-layout row wrap>
        <v-flex lg12>
            <v-card>
                <hpo-filter v-if="!showOnReport" :orderbutton="true" :listStatus="listStatus" :orderSummary="orderSummary" :headers="filter_headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                <v-widget title="Thống kê chi phí" v-if="!showOnReport && selectedOrders.length > 0">
                    <div slot="widget-header-action">
                        <v-layout row wrap class="pr-1" justify-end>
                            <div class="ml-2">
                                <order-flag-menu :orderIDs="selectedOrders.map(item => item.ID)" :orderType="2"></order-flag-menu>
                            </div>
                        </v-layout>
                    </div>
                    <div slot="widget-content">
                        <v-layout class="font-weight-bold" row wrap>
                            <v-flex lg3 sm3 pa-0>
                                <v-card-text>Số đơn hàng:</v-card-text>
                            </v-flex>
                            <v-flex lg9 sm9 pa-0>
                                <v-card-text>{{selectedOrders.length}}</v-card-text>
                            </v-flex>
                        </v-layout>
                        <v-layout class="font-weight-bold" row wrap>
                            <v-flex lg3 sm3 pa-0>
                                <v-card-text>Tổng tiền:</v-card-text>
                            </v-flex>
                            <v-flex lg9 sm9 pa-0>
                                <v-card-text>{{selectedOrders.map(item => item.TotalPriceVND).reduce((prev, curr) => prev + curr, 0) | currency}}</v-card-text>
                            </v-flex>
                        </v-layout>
                        <v-layout class="font-weight-bold" row wrap>
                            <v-flex lg3 sm3 pa-0>
                                <v-card-text>Đã trả:</v-card-text>
                            </v-flex>
                            <v-flex lg9 sm9 pa-0>
                                <v-card-text>{{selectedOrders.map(item => item.Payment).reduce((prev, curr) => prev + curr, 0) | currency}}</v-card-text>
                            </v-flex>
                        </v-layout>
                        <v-layout class="font-weight-bold" row wrap>
                            <v-flex lg3 sm3 pa-0>
                                <v-card-text>Còn thiếu:</v-card-text>
                            </v-flex>
                            <v-flex lg9 sm9 pa-0>
                                <v-card-text>{{(selectedOrders.map(item => item.TotalPriceVND).reduce((prev, curr) => prev + curr, 0) - selectedOrders.map(item => item.Payment).reduce((prev, curr) => prev + curr, 0)) | currency}}</v-card-text>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-widget>
                <v-data-table class="order-row-64" :headers="headers" :items="orders" :must-sort="true" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :loading="loading" :mobile-breakpoint="100" item-key="ID" show-select v-model="selectedOrders">
                    <template v-slot:item="{ item, isSelected, select}">
                        <tr :active="isSelected" :id="'r-' + item.ID">
                            <td @click="select(!isSelected)"><v-checkbox primary hide-details :input-value="isSelected"></v-checkbox></td>
                            <td>
                                <a target="blank" :href="`/ky-gui/ky-gui-lo/${item.ID}?UID=${item.UID}`">{{ (item.DepositCode ? item.DepositCode : 'KG') + item.ID }}</a>
                            </td>
                            <td>{{ item.ParentID ? 'MD' + item.ParentID : '' }}</td>
                            <td class="text-end font-weight-bold">{{ item.OrderWeight | currency('', item.FeeShipType == 1 ? 2 : 1)}}</td>
                            <td class="text-end font-weight-bold">{{ item.TotalPriceVND | currency}}</td>
                            <td>{{ item.Username }}</td>
                            <td>{{ item.ProvinceID | display_value(provinces, 'id', 'name') }}</td>
                            <td v-if="adminRole">
                                <v-edit-dialog :return-value.sync="item.CustomerServiceID" large lazy persistent @save="saveDetail({OrderID: item.ID, CustomerServiceID: item.CustomerServiceID | 0})">
                                    <div>{{ item.CustomerServiceID | display_value(staffs, "ID", "FullName") }}</div>
                                    <template v-slot:input>
                                    <v-select
                                        :items="staffs"
                                        v-model="item.CustomerServiceID"
                                        item-text="FullName"
                                        item-value="ID"
                                        clearable
                                    ></v-select>
                                    </template>
                                </v-edit-dialog>
                            </td>
                            <td v-else>{{ item.CustomerServiceID | display_value(staffs, "ID", "FullName") }}</td>
                            <td v-if="!storeRole">
                                <v-edit-dialog :return-value.sync="item.SalerTransportID" large lazy persistent @save="saveDetail({OrderID: item.ID, SalerTransportID: item.SalerTransportID | 0})">
                                    <div>{{ item.SalerTransportID | display_value(staffs, "ID", "FullName") }}</div>
                                    <template v-slot:input>
                                    <v-select
                                        :items="staffs"
                                        v-model="item.SalerTransportID"
                                        item-text="FullName"
                                        item-value="ID"
                                        :item-disabled="(item) => !item.is_active"
                                        clearable
                                    ></v-select>
                                    </template>
                                </v-edit-dialog>
                            </td>
                            <td v-else>{{ item.SalerTransportID | display_value(staffs, "ID", "FullName") }}</td>
                            <td v-if="!storeRole">
                                <v-edit-dialog :return-value.sync="item.SalerID" large lazy persistent @save="saveDetail({OrderID: item.ID, SalerID: item.SalerID | 0})">
                                    <div>{{ item.SalerID | display_value(staffs, "ID", "FullName") }}</div>
                                    <template v-slot:input>
                                    <v-select
                                        :items="staffs"
                                        v-model="item.SalerID"
                                        item-text="FullName"
                                        item-value="ID"
                                        clearable
                                    ></v-select>
                                    </template>
                                </v-edit-dialog>
                            </td>
                            <td v-else>{{ item.SalerID | display_value(staffs, "ID", "FullName") }}</td>
                            <td>
                                {{ item.IsFragileGoods ? 'Đóng gỗ' : '' }}
                                <br v-if="item.IsFoam" />
                                {{ item.IsFoam ? 'Bọt khí' : '' }}
                                <br v-if="item.IsCheck" />
                                {{ item.IsCheck ? 'Kiểm hàng' : '' }}
                                <br v-if="item.GuaranteeType" />
                                {{ item.GuaranteeType ? 'Bảo hiểm' : '' }}
                            </td>
                            <td> 
                                {{ item.CreatedDate | display_date('DD-MM-YYYY')}}
                                <br />
                                {{ item.CreatedDate | display_date('HH:mm:ss')}}
                            </td>
                            <td>
                                {{ item.StoreCNExDate | display_date('DD-MM-YYYY')}}
                                <br />
                                {{ item.StoreCNExDate | display_date('HH:mm:ss')}}
                            </td>
                            <td>
                                {{ item.StoreVNExDate | display_date('DD-MM-YYYY')}}
                                <br />
                                {{ item.StoreVNExDate | display_date('HH:mm:ss')}}
                            </td>
                            <td>
                                {{ item.IsExtendOrder ? 'Đơn bổ sung' : ''}}
                            </td>
                            <td>
                                <v-btn :color="item.Status | order_status_color(1)" small dark depressed outlined block @click="gotoDetail(item.ID, item.UID)">{{ item.Status | order_status(1)}}</v-btn>
                                <span class="order-status-additional red--text" v-if="item.RealStoreName">{{item.RealStoreName}}</span>
                                <span class="order-status-additional" v-else>{{getStoreName(item.Status, item.ChinaStoreID, item.ReceivePlaceID)}}</span>
                                <span class="order-status-additional" v-if="item.UnPayable">Đơn hàng tồn tại kiện chưa có số liệu</span>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-layout>
    <v-dialog v-model="dialogNew" max-width="900px">
      <v-card>
        <v-card-title>
          <span class="title">Tạo mới đơn hàng</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-form ref="entryForm">
                <v-layout row wrap>
                    <v-flex lg12 md12 sm12 xs12>
                        <v-layout row wrap>
                            <!-- <v-flex lg4 md4 sm12 xs12>
                                <v-select label="Loại đơn" v-model="newOrder.PriceType" :items="priceTypes" item-text="name" item-value="value" :rules="requireRules"></v-select>
                            </v-flex> -->
                            <v-flex lg4 md4 sm12 xs12>
                                <v-autocomplete label="Khách hàng" v-model="newOrder.UID" :items="customers" :item-text="getCustomerText" item-value="ID" @change="onSelectCustomer" :rules="requireRules"></v-autocomplete>
                            </v-flex>
                            <v-flex lg12 md12 sm12 xs12 v-if="newOrder.PriceType == price_type_enum.gui_nguoc">
                                <v-textarea label="Địa chỉ nhận" rows="3" v-model="newOrder.ReceiveAddress" :rules="requireRules"></v-textarea>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex lg4 md4 sm12 xs12>
                                <v-autocomplete label="Kho gửi" v-model="newOrder.ChinaStoreID" :items="listSourceStore" item-text="Name" item-value="ID" :rules="requireRules"></v-autocomplete>
                            </v-flex>
                            <v-flex lg4 md4 sm12 xs12>
                                <v-autocomplete label="Kho nhận" v-model="newOrder.ReceivePlaceID" :items="listDestStore" item-text="Name" item-value="ID" :rules="requireRules"></v-autocomplete>
                            </v-flex>
                            <v-flex lg4 md4 sm12 xs12 v-if="newOrder.PriceType == price_type_enum.gui_nguoc">
                                <v-text-field label="Số kiện hàng" v-model="newOrder.NumberOfPack" :step="1" class="input-group--focused" :rules="requireRules"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-flex lg12 md12 sm12 xs12>
                            <v-autocomplete label="Cấp độ an toàn" clearable v-model="newOrder.SafeLevelID" :items="safeLevels" item-text="Name" item-value="ID" item-disabled="HideOnAdmin"></v-autocomplete>
                        </v-flex>
                        <v-flex lg12 md12 sm12 xs12 v-if="newOrder.PriceType == price_type_enum.don_thuong">
                            <p class="body-2 font-weight-bold text-red">Danh sách vận đơn (Số lượng: {{newOrder.TransactionCodes.length}})</p>
                            <v-list>
                                <v-list-item v-for="(item, index) in newOrder.TransactionCodes" :key="item.ID">
                                    <v-list-item-content>
                                        <v-flex lg3 md3 sm12 xs12>
                                            <v-text-field label="Mã vận đơn" v-model="item.TransactionCode"></v-text-field>
                                        </v-flex>
                                        <v-flex lg3 md3 sm12 xs12>
                                            <v-text-field label="Tên hàng hoá" v-model="item.ProductName"></v-text-field>
                                        </v-flex>
                                        <v-flex lg2 md2 sm12 xs12>
                                            <h-currency-input label="Phí ship nội địa(¥)" :decimal="2" v-model="item.FeeShip"></h-currency-input>
                                        </v-flex>
                                        <v-flex lg2 md2 sm12 xs12>
                                            <h-currency-input label="Giá trị(¥)" :decimal="1" v-model="item.ProductAmount"></h-currency-input>
                                        </v-flex>
                                        <v-flex lg2 md2 sm12 xs12>
                                            <h-currency-input label="Số kiện" :decimal="0" v-model="item.NumberOfPack"></h-currency-input>
                                        </v-flex>
                                        <v-flex lg12 md12 sm12 xs12>
                                            <v-textarea v-model="item.OrderNote" background-color="#fefefe" dense rows="3" outlined label="Ghi chú"></v-textarea>
                                        </v-flex>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                    <v-btn icon @click="newOrder.TransactionCodes.splice(index, 1);">
                                        <v-icon>fa-trash-alt</v-icon>
                                    </v-btn>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-list>
                            <v-layout row wrap>
                                <v-divider class="ma-0"></v-divider>
                                <v-flex lg4 md4 sm12 xs12>
                                    <v-text-field label="Mã vận đơn" v-model="newTransaction.TransactionCode"></v-text-field>
                                </v-flex>
                                <v-flex lg4 md4 sm12 xs12>
                                    <h-currency-input label="Phí ship nội địa kho gửi(¥)" :decimal="2" v-model="newTransaction.FeeShip"></h-currency-input>
                                </v-flex>
                                <v-flex lg4 md4 sm12 xs12>
                                    <h-currency-input label="Giá trị(¥)" :decimal="1" v-model="newTransaction.ProductAmount"></h-currency-input>
                                </v-flex>
                                <v-flex lg4 md4 sm12 xs12>
                                    <v-text-field label="Tên hàng hoá" v-model="newTransaction.ProductName"></v-text-field>
                                </v-flex>
                                <v-flex lg4 md4 sm12 xs12>
                                    <h-currency-input label="Số kiện" :decimal="0" v-model="newTransaction.NumberOfPack"></h-currency-input>
                                </v-flex>
                                <!-- <v-flex lg4 md4 sm12 xs12>
                                    <h-currency-input label="Số kiện tương tự" :decimal="0" v-model="newTransaction.SameNumberOfPack"></h-currency-input>
                                </v-flex> -->
                                <v-flex lg4 md4 sm12 xs12>
                                    <v-btn icon large @click="appendTransactionCode"><v-icon color="#dc3545">far fa-plus-square</v-icon></v-btn>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-flex>
                </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1 white--text" @click="dialogNew = false">Đóng</v-btn>
          <v-btn color="red darken-1 white--text" @click="createNewOrder">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <upload-file :dialogUpload="dialogImport" title="Import đơn hàng" temp_file="/import_ky_gui.xlsx" @closePopup="dialogImport=false" @importFile="importData"></upload-file>
</v-container>
</template>

<script>
import {
    mapState
} from "vuex";
import configs from "@/configs";
import _ from "lodash";
import Filtering from "@/components/Filtering";
import { sendErrorNotice, sendSuccessNotice } from "@/commons/utils";
import VWidget from "@/components/VWidget";
import OrderFlag from "@/components/widgets/OrderFlag";
import upload_file from "@/components/popups/upload_file";
export default {
    components: {
        VWidget,
        "hpo-filter": Filtering,
        'order-flag-menu': OrderFlag,
        "upload-file": upload_file,
    },
    props: ["showOnReport", "filterReport"],
    data() {
        return {
            requireRules: [(v) => !!v || "Trường dữ liệu không được để trống."],
            search: "",
            selectedOrders: [],
            headers: [
                {
                    text: "Mã ký gửi",
                    value: "ID",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Đơn mua hộ",
                    value: "ParentID",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng cân/khối",
                    value: "OrderWeight",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Tổng tiền",
                    value: "TotalPriceVND",
                    align: "end",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Number"]
                },
                {
                    text: "Khách hàng",
                    value: "Username",
                    quickSearch: true,
                    filterable: true,
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Tỉnh/TP",
                    value: "ProvinceID",
                    filterable: true,
                    values: [],
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Nhân viên CS",
                    value: "CustomerServiceID",
                    quickSearch: true,
                    filterable: true,
                    values: [],
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Sale vận chuyển",
                    value: "SalerTransportID",
                    quickSearch: true,
                    filterable: true,
                    values: [],
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Sale nhập hàng",
                    value: "SalerID",
                    quickSearch: true,
                    filterable: true,
                    values: [],
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Lưu ý đặc biệt",
                    sortable: false,
                    filterable: false,
                },
                {
                    text: "Ngày đặt hàng",
                    value: "CreatedDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Xuất kho gửi",
                    value: "StoreCNExDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Xuất kho nhận",
                    value: "StoreVNExDate",
                    filterable: true,
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Đơn bổ sung",
                    value: "IsExtendOrder",
                    filterable: true,
                    values: [{value: 0, name: 'No'}, {value: 1, name: 'Yes'}],
                    dataType: configs.DATA_TYPE["Enum"]
                },
                {
                    text: "Trạng thái",
                    value: "Status",
                    filterable: true,
                    align: "center",
                    dataType: configs.DATA_TYPE["Enum"],
                    values: configs.ORDER_DEPOSIT_STATUS
                }
            ],
            priceTypes: configs.PRICE_TYPE_LIST,
            price_type_enum: configs.PRICE_TYPE_ENUM,
            order_deposit_status: configs.ORDER_DEPOSIT_STATUS,
            pagination: { ...configs.PAGINATION, sortBy: ["ID"]},
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            viewName: "deposit_list",
            filterConditions: [],
            quickFilterConditions: [],
            dialogNew: false,
            dialogImport: false,
            newTransaction: {
                TransactionCode: '',
                VbiCode: '',
                Status: 1,
                UID: 0,
                OrderID: 0,
                PackageType: 1,
                OrderNote: '',
                ProductName: '',
                ProductAmount: 0,
                NumberOfPack: 0
            },
            newOrder: {
                UID: 0,
                Status: 16,
                PriceType: 1,
                NumberOfPack: 0,
                ReceiveAddress: '',
                TransactionCodes: []
            }
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
        order_type() {
            this.filter_data();
        },
        staffs() {
            let header_item = _.find(this.headers, { value: "CustomerServiceID" });
            if (header_item) {
                header_item.values =
                _.map(this.staffs, (item) => {
                    return {
                    value: item.ID,
                    name: item.FullName,
                    };
                }) || [];
            }
            header_item = _.find(this.headers, { value: "SalerID" });
            if (header_item) {
                header_item.values =
                _.map(this.staffs, (item) => {
                    return {
                    value: item.ID,
                    name: item.FullName,
                    };
                }) || [];
            }
            header_item = _.find(this.headers, { value: "SalerTransportID" });
            if (header_item) {
                header_item.values =
                _.map(this.staffs, (item) => {
                    return {
                    value: item.ID,
                    name: item.FullName,
                    };
                }) || [];
            }
        },
        provinces() {
            let header_item = _.find(this.headers, {value: "ProvinceID"});
            if(header_item) {
                header_item.values = _.map(this.provinces, (item) => {
                return {
                    value: item.id,
                    name: item.name
                }
                }) || []
            }
        },
        filterReport: function(val) {
            if(this.showOnReport) {
                this.filter_data();
            }
        }
    },
    computed: {
        ...mapState({
            configuration: state => state.configuration.selected,
            orders: state => state.deposit.all.data,
            total_rows: state => state.deposit.all.total,
            loading: state => state.deposit.loading,
            orderSummary: state => state.deposit.all.summary,
            customers: state => state.customer.master.data,
            warehouses: state => state.commons.stores,
            chinaStores: state => state.commons.chinaStores,
            staffs: state => _.filter(state.commons.all_users, function(o) {
                return (o.RoleType & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService && (o.RoleType & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase;
            }),
            guarantees: state => {
                let tmp = [{name: 'Không sử dụng', value: 0}];
                if(state.feeGuarantee.all.data) {
                state.feeGuarantee.all.data.forEach(element => {
                    tmp.push({name: element.PackageName, value: element.ID});
                });
                }
                return tmp;
            },
            provinces: state => state.commons.provinces,
            safeLevels: state => state.safeLevel.all.data,
            allFlags: state => _.map(state.flag.all.data, (item) => {
                return {
                    value: item.ID,
                    name: item.FlagName,
                    color: item.FlagColor
                }
            })
        }),
        order_type() {
            return this.$route.path.includes('ky-gui-lo') ? configs.PRICE_TYPE_ENUM.don_thuong : configs.PRICE_TYPE_ENUM.gui_nguoc;
        },
        product_types() {
            return this.configuration && this.configuration.ProductTypes ? JSON.parse(this.configuration.ProductTypes) : [];
        },
        listSourceStore() {
            return this.newOrder.PriceType == configs.PRICE_TYPE_ENUM.don_thuong ? 
            _.filter(this.chinaStores, (p) => {
                return p.StoreType == configs.PRICE_TYPE_ENUM.don_thuong && !p.IsHidden
            }) : 
            _.filter(this.chinaStores, (p) => {
                return p.StoreType == configs.PRICE_TYPE_ENUM.gui_nguoc && !p.IsHidden
            });
        },
        listDestStore() {
            return this.newOrder.PriceType == configs.PRICE_TYPE_ENUM.don_thuong ? 
            _.filter(this.warehouses, (p) => {
                return p.StoreType == configs.PRICE_TYPE_ENUM.don_thuong && !p.IsHidden
            }) : 
            _.filter(this.warehouses, (p) => {
                return p.StoreType == configs.PRICE_TYPE_ENUM.gui_nguoc && !p.IsHidden
            });
        },
        listStatus() {
            return configs.ORDER_DEPOSIT_STATUS;
        },
        adminRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
        },
        storeRole() {
            return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreTQ) == configs.ROLE_TYPE.StoreTQ || (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreVN) == configs.ROLE_TYPE.StoreVN;
        },
        filter_headers() {
            let tmp = [...this.headers];
            tmp.push({
                text: "Đóng gỗ",
                value: "IsFragileGoods",
                filterable: true,
                values: [{value: 0, name: 'N'}, {value: 1, name: 'Y'}],
                dataType: configs.DATA_TYPE["Enum"]
                });
            tmp.push({
                text: "Kiểm hàng",
                value: "IsCheck",
                filterable: true,
                values: [{value: 0, name: 'N'}, {value: 1, name: 'Y'}],
                dataType: configs.DATA_TYPE["Enum"]
                });
            tmp.push({
                text: "Bảo hiểm",
                value: "GuaranteeType",
                filterable: true,
                values: this.guarantees,
                dataType: configs.DATA_TYPE["Enum"]
                });
            tmp.push({
                text: "Ngày thanh toán",
                value: "PaymentDate",
                filterable: true,
                dataType: configs.DATA_TYPE["Date"]
            });
            tmp.push({
                text: "Nhập kho gửi",
                value: "StoreCNImportDate",
                filterable: true,
                dataType: configs.DATA_TYPE["Date"]
            });
            tmp.push({
                text: "Nhập kho nhận",
                value: "StoreVNImDate",
                filterable: true,
                dataType: configs.DATA_TYPE["Date"]
            });
            tmp.push({
                text: "Đơn giá VCQT (NY)",
                value: "ListedWeightPrice",
                filterable: true,
                dataType: configs.DATA_TYPE["Number"]
            });
            tmp.push({
                text: "Đơn giá VCQT",
                value: "WeightPrice",
                filterable: true,
                dataType: configs.DATA_TYPE["Number"]
            });
            tmp.push({
                text: "Đã thanh toán",
                value: "PaymentStatus",
                filterable: true,
                values: [{value: 0, name: 'No'}, {value: 1, name: 'Yes'}],
                dataType: configs.DATA_TYPE["Enum"]
            });
            tmp.push({
                text: "Xuất khẩu",
                value: "PriceType",
                filterable: true,
                values: configs.PRICE_TYPE_LIST,
                dataType: configs.DATA_TYPE["Enum"]
            });
            tmp.push({
                text: "Lý do huỷ đơn",
                value: "CancelReason",
                filterable: true,
                values: configs.CANCEL_REASON,
                dataType: configs.DATA_TYPE["Enum"]
            });
            tmp.push({
                text: "Đơn đầu tiên",
                value: "IsFirstOrder",
                filterable: true,
                values: [{value: 0, name: 'No'}, {value: 1, name: 'Yes'}],
                dataType: configs.DATA_TYPE["Enum"]
            });
            tmp.push({
                text: "Đã kiểm tra tài chính",
                value: "CheckPayment",
                filterable: true,
                values: [{value: 0, name: 'No'}, {value: 1, name: 'Yes'}],
                dataType: configs.DATA_TYPE["Enum"]
            });
            tmp.push({
                text: "Loại hàng",
                value: "ProductType",
                filterable: true,
                values: this.product_types,
                dataType: configs.DATA_TYPE["Enum"]
            });
            tmp.push({
                text: "Kho gửi",
                value: "ChinaStoreID",
                filterable: true,
                values: _.map(this.chinaStores, (item) => {
                    return {
                    value: item.ID,
                    name: item.Name,
                    };
                }) || [],
                dataType: configs.DATA_TYPE["Enum"]
            });
            tmp.push({
                text: "Kho nhận",
                value: "ReceivePlaceID",
                filterable: true,
                values: _.map(this.warehouses, (item) => {
                    return {
                    value: item.ID,
                    name: item.Name,
                    };
                }) || [],
                dataType: configs.DATA_TYPE["Enum"]
            });
            tmp.push({
                text: "Hashtag",
                value: "FlagID",
                filterable: true,
                dataType: configs.DATA_TYPE["Enum"],
                values: this.allFlags
            });
            tmp.push({
                text: "Thiếu kiện",
                value: "IsPackNotMatch",
                filterable: true,
                dataType: configs.DATA_TYPE["Enum"],
                values: [{value: 0, name: 'No'}, {value: 1, name: 'Yes'}],
            });
            return tmp;
        },
    },
    methods: {
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: _.cloneDeep(this.filterConditions), // Clone the filter conditions
                quickFilter: this.quickFilterConditions
            };
            if(this.showOnReport) {
                param.filter = _.cloneDeep(this.filterReport); // Also clone if using filterReport
            }
            if(this.order_type) {
                param.filter.push({column: 'PriceType', condition: 'equal', value: this.order_type});
            }
            this.$store.dispatch("deposit/getList", param);
            this.$store.dispatch("feeGuarantee/getList");
        },
        gotoDetail: function (id, uid) {
            let routeData = this.$router.resolve({
                name: "DepositDetail",
                params: {
                    Pid: id,
                    title: `Chi tiết đơn hàng (#${id})`
                },
                query: {
                    'uid': uid
                }
            });
            window.open(routeData.href, "_blank");
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        get_status_color(val, enums) {
            return this.$options.filters.display_color(val, enums);
        },
        getCustomerText(item) {
            return `${item.ID} - ${item.Username}`
        },
        getCustomerList() {
            this.$store.dispatch("customer/getCustomerList", {
                is_master: 1,
                fields: ["ID", "Username", "ReceivePlaceID", "ChinaStoreID"]
            });
        },
        appendTransactionCode() {
            if(this.newTransaction.TransactionCode == '') {
                sendErrorNotice("Mã vận đơn không được để trống!");
                return;
            }
            if(!this.newTransaction.NumberOfPack) {
                sendErrorNotice("Số lượng kiện phải lớn hơn 0!");
                return;
            }
            this.newOrder.TransactionCodes.push({...this.newTransaction});
            if(this.newTransaction.SameNumberOfPack) {
                let tran_code = this.newTransaction.TransactionCode;
                for (let i = 0; i < this.newTransaction.SameNumberOfPack - 1; i++) {
                    this.newTransaction.TransactionCode = tran_code + '_' + (i+2)
                    this.newOrder.TransactionCodes.push({...this.newTransaction, FeeShip: 0});
                }
            } 
            
            this.newTransaction = {
                TransactionCode: '',
                VbiCode: '',
                Status: 1,
                UID: 0,
                OrderID: 0,
                PackageType: 1,
                OrderNote: '',
                ProductName: '',
                ProductAmount: 0,
                NumberOfPack: 0,
                GuaranteeRate: 0
            }
        },
        createData() {
            this.dialogNew = true;
            this.newOrder.PriceType = this.order_type;
        },
        createNewOrder() {
            if (!this.$refs.entryForm.validate()){
                return;
            }
            if(this.newOrder.PriceType == this.price_type_enum.don_thuong && this.newOrder.TransactionCodes.length == 0) {
                sendErrorNotice("Hãy nhập danh sách mã vận đơn!");
                return;
            }
            if(this.newOrder.PriceType == this.price_type_enum.gui_nguoc) {
                for (let i = 0; i < this.newOrder.NumberOfPack; i++) {
                    this.newOrder.TransactionCodes.push({...this.newTransaction, VbiCode: Math.random().toString(36).slice(2, 10)})
                }
            }
            const cust = _.find(this.customers, {'ID': this.newOrder.UID});
            this.newOrder.Username = cust.Username;

            this.$store.dispatch("deposit/setDetail", {'data': this.newOrder});
            this.newOrder = {
                UID: 0,
                Status: 16,
                ReceiveAddress: '',
                TransactionCodes: []
            };
            this.dialogNew = false;
            sendSuccessNotice('Tạo mới đơn hàng thành công.');
        },
        exportFile() {
            var param = {
                filter: _.cloneDeep(this.filterConditions), 
                quickFilter: this.quickFilterConditions
            };
            if(this.order_type) {
                param.filter.push({column: 'PriceType', condition: 'equal', value: this.order_type});
            }
            this.$store.dispatch("deposit/exportList", param);
        },
        saveDetail(item) {
            this.$store.dispatch("deposit/setDetail", {'data': item});
        },
        onSelectCustomer() {
            const cust = _.find(this.customers, {'ID': this.newOrder.UID});
            if(this.newOrder.PriceType == this.price_type_enum.don_thuong) {
                this.newOrder.ReceivePlaceID = cust.ReceivePlaceID;
                this.newOrder.ChinaStoreID = cust.ChinaStoreID;
            }
        },
        getStoreName(status, chinaStoreID, receivePlaceID) {
            if(status == 11 || status == 16) {
                const store = _.find(this.chinaStores, { ID: chinaStoreID})
                return store ? store.Name : ''
            }
            if(status == 12 || status == 7 || status == 9) {
                const store = _.find(this.warehouses, { ID: receivePlaceID})
                return store ? store.Name : ''
            }
            return ''
        },
        onImport() {
            this.dialogImport = true;
        },
        importData(filelist) {
            for(const f of filelist) {
                const formData = new FormData();
                formData.append('excel_file', f);
                formData.append('filename', f.name);
                this.$store.dispatch("deposit/import_deposit", formData);
            }
            this.dialogImport = false;
        }
    },
    created() {
        this.$store.dispatch("commons/getAllUsers");
    },
    mounted() {
        this.getCustomerList();
        this.$store.dispatch("configuration/getDetail", 1);
        this.$store.dispatch("commons/getProvinces", {});
        this.$store.dispatch("commons/getAllStores");
        this.$store.dispatch("commons/getAllChinaStores");
        this.$store.dispatch("safeLevel/getList");
        this.$store.dispatch("flag/getList");
        this.$root.$on("REQUEST_CREATE_DATA", this.createData);
        this.$root.$on("REQUEST_SAVE_DATA", this.exportFile);
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("REQUEST_OTHER_ACTION", this.onImport);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_CREATE_DATA");
        this.$root.$off("REQUEST_SAVE_DATA");
        this.$root.$off("REQUEST_REFRESH_DATA");
        this.$root.$off("REQUEST_OTHER_ACTION");
    }
};
</script>
